import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { INote } from 'app/models/note';

@Injectable({providedIn: 'root'})
export class NoteService {
  private api: string = environment.privateApi + 'Note/';
  private http = inject(HttpClient);

  public createNote(text: string, entityId: number, entityType: string): Observable<INote>{
    return this.http.post<INote>(this.api + 'CreateNote/' + text + '/' + entityId + '/' + entityType, null);
  }

  public getNotes(entityId: number, entityType: string, includeArchived: boolean): Observable<INote[]>{
    return this.http.get<INote[]>(this.api + 'GetNotes/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  public archiveNote(noteId: number, archived: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveNote/' + noteId + '/' + archived, null);
  }
}
